import { gql } from '@apollo/client';

export const COMPANY_TYPES_PAGE_QUERY = gql`
  query companyTypes(
    $limit: Int!
    $offset: Int!
    $q: String
    $withDeleted: Boolean
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    companyTypes(
      limit: $limit
      offset: $offset
      q: $q
      withDeleted: $withDeleted
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      hasDraft
      currentVersion {
        deletedAt
        id
        createdById
        description
        name
        status
        updatedById
        version
      }
    }
    companyTypesPageInfo(
      q: $q
      columnFilters: $columnFilters
      withDeleted: $withDeleted
    ) {
      totalCount
    }
  }
`;

export const COMPANY_TYPES_QUERY = gql`
  query companyTypes($limit: Int!, $offset: Int!, $q: String, $withDeleted: Boolean) {
    companyTypes(limit: $limit, offset: $offset, q: $q, withDeleted: $withDeleted) {
      id
      hasDraft
      currentVersion {
        id
        createdById
        description
        name
        status
        updatedById
        version
        deletedAt
      }
    }
  }
`;

export const COMPANY_TYPE_QUERY = gql`
  query companyType($id: Int!) {
    companyType(id: $id) {
      id
      isSystemType
      currentVersion {
        deletedAt
        id
        createdById
        description
        name
        status
        updatedById
        version
      }
    }
  }
`;

export const COMPANY_TYPE_VERSIONS_QUERY = gql`
  query companyTypeVersions($limit: Int, $offset: Int, $companyTypeId: Int!) {
    companyTypeVersions(
      limit: $limit
      offset: $offset
      companyTypeId: $companyTypeId
    ) {
      deletedAt
      companyTypeId
      createdAt
      createdById
      description
      id
      name
      status
      updatedAt
      updatedById
      version
    }
  }
`;
